const values = [
  {
    id: 'CASH',
    name: 'Dinheiro',
  },
  {
    id: 'BANK_TRANSFER',
    name: 'PIX / Transferência',
  },
  {
    id: 'CREDIT_CARD',
    name: 'Cartão de Crédito',
  },
  {
    id: 'DEBIT_CARD',
    name: 'Cartão de Débito',
  },
  {
    id: 'CHECK',
    name: 'Cheque',
  },
  {
    id: 'COURTESY',
    name: 'Cortesia',
  },
  {
    id: 'CREDIT',
    name: 'Crédito do Cliente',
  },
];

const ENUM_VALUES_MAP = values.reduce((obj, item) => {
  obj[item.id] = item;
  return obj;
}, {});

const PaymentMethodsEnum = {
  ...values.reduce((obj, item) => {
    obj[item.id] = item.id;
    return obj;
  }, {}),

  getById(id) {
    return ENUM_VALUES_MAP[id];
  },
  getValues() {
    return values.filter((p) => p.id !== PaymentMethodsEnum.CREDIT);
  },
  getAllValuesIncludingCredit() {
    return values;
  },

  getIcon(id) {
    if (PaymentMethodsEnum.DEBIT_CARD === id || PaymentMethodsEnum.CREDIT_CARD === id) {
      return 'credit-card';
    }
    if (PaymentMethodsEnum.CHECK === id) {
      return 'money-check-dollar';
    }
    if (PaymentMethodsEnum.BANK_TRANSFER === id) {
      return 'building-columns';
    }
    if (PaymentMethodsEnum.COURTESY === id) {
      return 'gift';
    }
    if (PaymentMethodsEnum.CREDIT === id) {
      return 'coins';
    }
    return 'dollar-sign';
  },

  getShortLabel(id) {
    if (PaymentMethodsEnum.CREDIT_CARD === id) {
      return 'Crédito';
    }
    if (PaymentMethodsEnum.DEBIT_CARD === id) {
      return 'Débito';
    }
    if (PaymentMethodsEnum.BANK_TRANSFER === id) {
      return 'Trans / PIX';
    }
    if (PaymentMethodsEnum.CREDIT === id) {
      return 'Crédito Cliente';
    }
    return ENUM_VALUES_MAP[id]?.name;
  },
};

export default PaymentMethodsEnum;
